import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingSkeleton = () => {
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-accent rounded-lg flex items-center justify-center">
            <Icon name="Loader2" size={20} color="white" className="animate-spin" />
          </div>
          <div>
            <div className="h-5 bg-muted rounded w-32 mb-2 animate-pulse" />
            <div className="h-4 bg-muted/60 rounded w-48 animate-pulse" />
          </div>
        </div>
      </div>
      {/* Credibility Score Skeleton */}
      <div className="p-6 rounded-xl border border-border bg-card">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 bg-muted rounded animate-pulse" />
            <div>
              <div className="h-5 bg-muted rounded w-32 mb-2 animate-pulse" />
              <div className="h-4 bg-muted/60 rounded w-40 animate-pulse" />
            </div>
          </div>
          <div className="text-right">
            <div className="h-8 bg-muted rounded w-16 mb-1 animate-pulse" />
            <div className="h-3 bg-muted/60 rounded w-20 animate-pulse" />
          </div>
        </div>
        
        <div className="w-full bg-muted rounded-full h-2 animate-pulse">
          <div className="h-2 bg-muted/60 rounded-full w-3/4 animate-pulse" />
        </div>
      </div>
      {/* Summary Skeleton */}
      <div className="bg-card rounded-xl shadow-soft border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <div className="w-5 h-5 bg-muted rounded animate-pulse" />
            <div className="h-5 bg-muted rounded w-32 animate-pulse" />
          </div>
          <div className="h-8 bg-muted rounded w-16 animate-pulse" />
        </div>
        <div className="space-y-3">
          <div className="h-4 bg-muted rounded w-full animate-pulse" />
          <div className="h-4 bg-muted rounded w-5/6 animate-pulse" />
          <div className="h-4 bg-muted rounded w-4/5 animate-pulse" />
          <div className="h-4 bg-muted rounded w-3/4 animate-pulse" />
        </div>
      </div>
      {/* Evidence Sources Skeleton */}
      <div className="bg-card rounded-xl shadow-soft border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <div className="w-5 h-5 bg-muted rounded animate-pulse" />
            <div className="h-5 bg-muted rounded w-40 animate-pulse" />
          </div>
          <div className="h-8 bg-muted rounded w-16 animate-pulse" />
        </div>
        
        <div className="space-y-4">
          {[1, 2, 3]?.map((index) => (
            <div key={index} className="p-4 bg-muted/30 rounded-lg border border-border/50">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="h-5 bg-muted rounded w-3/4 mb-2 animate-pulse" />
                  <div className="h-4 bg-muted/60 rounded w-full mb-2 animate-pulse" />
                  <div className="h-4 bg-muted/60 rounded w-2/3 mb-3 animate-pulse" />
                  <div className="flex items-center space-x-4">
                    <div className="h-3 bg-muted/60 rounded w-20 animate-pulse" />
                    <div className="h-3 bg-muted/60 rounded w-24 animate-pulse" />
                    <div className="h-3 bg-muted/60 rounded w-16 animate-pulse" />
                  </div>
                </div>
                <div className="h-8 bg-muted rounded w-16 ml-4 animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Progress Indicator */}
      <div className="bg-card rounded-xl shadow-soft border border-border p-6">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <Icon name="Search" size={20} color="var(--color-primary)" className="animate-pulse" />
            <span className="text-foreground font-medium">Analyzing claim...</span>
          </div>
          
          <div className="space-y-2 text-sm text-muted-foreground">
            <div className="flex items-center justify-center space-x-2">
              <Icon name="CheckCircle" size={14} color="var(--color-success)" />
              <span>Processing content</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <Icon name="Loader2" size={14} color="var(--color-primary)" className="animate-spin" />
              <span>Cross-referencing sources</span>
            </div>
            <div className="flex items-center justify-center space-x-2 opacity-50">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
              <span>Generating analysis</span>
            </div>
          </div>
          
          <div className="mt-6 w-full bg-muted rounded-full h-1">
            <div className="h-1 bg-gradient-primary rounded-full animate-pulse" style={{ width: '60%' }} />
          </div>
          
          <p className="mt-3 text-xs text-muted-foreground">
            This usually takes 10-30 seconds
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;